import siemensImage from './siemenslogo.svg'

const siemensLogo = props => {
  return siemensImage;
}

export default siemensLogo
